"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onScroll;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _browser = require("./browser");
var _global2 = _interopRequireDefault(require("./global"));
var _defaultWindow = _global2.default.document ? _global2.default : undefined;
var scrollers = [];

/**
 * Creates a scroller with methods to register and unregister handlers for
 * the given window.  Handlers will only be called when the browser is idle
 * (if requestIdleCallback is available) or soon after the event (if it's not
 * available).
 */
function createScrollers(_window) {
  var ticking = false;
  var idler = (0, _browser.getIdle)(_window);
  var handlers = [];

  /**
   * Call all registered handlers if time permits, otherwise reschedule.
   */
  function flush(deadline) {
    if (deadline.timeRemaining() <= 0 && !deadline.didTimeout) {
      // In an idle timeout instead and there's no time left
      idler(flush);
      return;
    }
    (0, _map.default)(handlers).call(handlers, handler => handler());
    ticking = false;
  }

  /**
   * Handle actual scroll events by scheduling a flush when idle.
   */
  function scrolled() {
    if (!ticking) {
      idler(flush);
    }
    ticking = true;
  }

  /**
   * Start listening for scroll events on the window.
   */
  function listen() {
    _window.addEventListener('scroll', scrolled, {
      passive: true
    });
  }

  /**
   * Stop listening for scroll events on the window.
   */
  function unlisten() {
    _window.removeEventListener('scroll', scrolled);
  }

  /**
   * Register a new handler for scroll events.
   */
  function register(handler) {
    // Start listening if this is the first handler
    if (handlers.length === 0) listen();
    handlers.push(handler);
  }

  /**
   * Unregister a handler for scroll events.
   */
  function unregister(handler) {
    var index = (0, _indexOf.default)(handlers).call(handlers, handler);

    // Handler not found
    if (!~index) return;

    // Stop listening if this is the last handler
    if (handlers.length === 1) unlisten();
    (0, _splice.default)(handlers).call(handlers, index, 1);
  }
  return {
    _window,
    register,
    unregister
  };
}

/**
 * Retrieve the scroller for the given window.
 */
function getScrollerFor(_window) {
  var found = (0, _reduce.default)(scrollers).call(scrollers, (result, scroller) => {
    if (result) return result;
    return scroller._window === _window ? scroller : false;
  }, false);
  if (found) return found;
  scrollers.push(createScrollers(_window));
  return scrollers[scrollers.length - 1];
}
function noop() {}

/**
 * Register a function to listen to scroll events on the given window.
 *
 * Returns a function which can be called to stop listening for scroll events.
 */
function onScroll(handler) {
  var _window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _defaultWindow;
  if (!_window) return noop;
  var {
    register,
    unregister
  } = getScrollerFor(_window);
  register(handler);
  return function stopListening() {
    unregister(handler);
  };
}